export default __webpack_public_path__ + "4edee91916ff97b8e8f10b0465c06666.png";